
const CURRENCY_SYMBOL_TO_CODE: Record<string, string> = {
    '$': 'USD',
    'US$': 'USD',
    '€': 'EUR',
    '£': 'GBP',
};

function normalizeCurrencyCode(currency?: string): string {
    const raw = String(currency || '').trim();
    if (!raw) {
        return 'USD';
    }

    if (CURRENCY_SYMBOL_TO_CODE[raw]) {
        return CURRENCY_SYMBOL_TO_CODE[raw];
    }

    const normalized = raw.toUpperCase().replace(/[^A-Z]/g, '');
    if (normalized.length === 3) {
        return normalized;
    }

    return 'USD';
}

export default function formatCurrency(
    value: number | null | undefined,
    currency: string = "USD",
    locale: string = "en-US"
): string {
    if (value === null || value === undefined || isNaN(value)) {
        return "-";
    }

    const safeCurrency = normalizeCurrencyCode(currency);

    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: safeCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    } catch (_error) {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }
}
